import React, { Component } from "react";
import { Link, useNavigate } from "react-router-dom";

import loading from "./loadrr.gif";
import darkmodeImg from "./darkmode.png";
import lightmodeImg from "./lightmode.png";

export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: "",
    };
  }

  handleSearchChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    if (this.state.searchInput.trim()) {
      this.props.onSearch(this.state.searchInput);
      window.location.hash = "/search";
    }
  };

  render() {
    return (
      <div>
        <nav
          className={`navbar  fixed-top navbar-expand-lg navbar-${this.props.mode} `}
          style={{
            backgroundColor: this.props.mode === "dark" ? "black" : "#F7CE4C",
            color: this.props.mode === "dark" ? "white" : "black",
          }}
        >
          <div className="container-fluid">
            <Link to="/">
              <div>
                <img className="titleIcon" src={loading} alt="icon" />{" "}
              </div>
            </Link>
            <Link className="navbar-brand myFontForTitle" to="/">
              BuzzBreif
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0 myFontForNavIcons">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/sports"
                  >
                    Sports
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/business"
                  >
                    Business
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/entertainment"
                  >
                    Entertainment
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/health"
                  >
                    Health
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/science"
                  >
                    Science
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/technology"
                  >
                    Technology
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    style={
                      this.props.mode === "dark"
                        ? { color: "white" }
                        : { color: "black" }
                    }
                    to="/bookmarks"
                  >
                    Bookmarks ❤️
                  </Link>
                </li>
              </ul>
              
              {/* Search Form */}
              <form className="d-flex search-form me-3" onSubmit={this.handleSearchSubmit}>
                <input
                  className={`form-control me-2 search-input ${this.props.mode === "dark" ? "dark-search" : ""}`}
                  type="search"
                  placeholder="Search news..."
                  value={this.state.searchInput}
                  onChange={this.handleSearchChange}
                />
                <button 
                  className="btn btn-outline-primary search-btn" 
                  type="submit"
                  disabled={!this.state.searchInput.trim()}
                >
                  🔍
                </button>
              </form>

              <div className="navbar-actions d-flex align-items-center">
                <div
                  className="mode-toggle"
                  onClick={this.props.toggleMode}
                  title={`Switch to ${
                    this.props.mode === "light" ? "Dark" : "Light"
                  } Mode`}
                >
                  <img
                    src={this.props.mode === "light" ? lightmodeImg : darkmodeImg}
                    alt={`Switch to ${
                      this.props.mode === "light" ? "dark" : "light"
                    } mode`}
                    className={`bee ${
                      this.props.mode === "light" ? "buzzing" : "sleeping"
                    }`}
                  />
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}
